export default __webpack_public_path__ + "static/media/img4.4b033d90.jpg";